import {MultiStore, StoreAreas, VerifyVoucherResponse} from 'types';
import {MembershipCard} from 'types/membership';

export type AppState = {
  defaultMembershipCard: MembershipCard | null | undefined;
  membershipCards: MembershipCard[];
  voucherData: VerifyVoucherResponse | undefined;
  currentStore?: CurrentStoreType | undefined;
  locations: StoreAreas[] | null;
  isDirectCheckout: boolean;
  accessTradeClickId: string | undefined;
  trueId: string | undefined;
  pricezaClickId: string | undefined;
  isAppLoading: boolean;
  appMode: AppMode;
  appVersion: string | undefined;
  deviceOS: string | undefined;
  resetEffectValue: number;
  isFromBasketNotification: boolean;
  showBuildInfo: boolean;
  needRetriggerCheckout: boolean;
};

export type AlertState = {
  type?: AlertType;
  details?: any;
};

export enum AlertType {
  voucherQuantityLimitExceeded,
  voucherExpired,
  voucherItemDeselected,
  voucherItemRemoved
}

export type CurrentStoreType = {
  zipcode: string;
  subdistrict: string;
  subdistrictEn?: string;
  subdistrictTh?: string;
  storeCodes: string[];
  showStorePickup: boolean;
  isSameDayDelivery: boolean | undefined;
  addressId?: string;
};

export type getStoreAreaFilter = {
  getAllStoreAreas?: boolean;
  subDistrictName?: string;
  districtName?: string;
  provinceName?: string;
  provinceId?: string;
  districtId?: string;
  subDistrictId?: string;
  zipCode?: string;
  limit?: number;
  page?: number;
  exactMatch?: boolean;
};

export interface StoreRelation {
  storeId: string;
  isExpress: boolean;
  isRegular: boolean;
}

export interface Province {
  id: string;
  nameTh: string;
  nameEn: string;
  status?: string;
  districts: District[];
}

export interface District {
  id: string;
  nameEn: string;
  nameTh: string;
  provinceId: string;
  subDistricts?: SubDistrict[];
  province?: Province;
}

export interface SubDistrict {
  code: string;
  nameEn: string;
  nameTh: string;
  zipCode: string;
  districtId: string;
  stores: StoreRelation[];
  district?: District;
  storesDetails?: MultiStore[];
}

export enum AffiliateProgramType {
  ACCESSTRADE = 'ACCESSTRADE',
  PRICEZA = 'PRICEZA',
  TRUEID = 'TRUEID'
}

export enum AppMode {
  regular = 'regular',
  express = 'express'
}
